import script from "./Histogram.vue?vue&type=script&lang=js"
export * from "./Histogram.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__